import type { PartialTranslation } from "./index";

/** Vietnamese — see `../../vi/index.ts` for the terminology notes. */
export const nav: PartialTranslation["nav"] = {
  sections: {
    learn: "Học",
    "my-space": "Của tôi",
    community: "Cộng đồng",
  },
  items: {
    home: "Trang chủ",
    browse: "Khám phá",
    videos: "Video",
    "random-question": "Quay & Nói",
    "my-topics": "Chủ đề của tôi",
    vocabulary: "Từ vựng của tôi",
    collections: "Bộ sưu tập",
    notes: "Ghi chú",
    progress: "Tiến độ",
    "study-groups": "Nhóm học",
    "ai-chat": "Trò chuyện AI",
    leaderboard: "Bảng xếp hạng",
  },
  groups: {
    myTopics: "Chủ đề & luyện tập",
    vocabulary: "Từ vựng",
    community: "Cộng đồng",
  },
  actions: {
    expand: "Mở rộng {{name}}",
    collapse: "Thu gọn {{name}}",
    expandSidebar: "Mở rộng thanh điều hướng",
    collapseSidebar: "Thu gọn thanh điều hướng",
  },
  header: {
    search: "Tìm chủ đề",
    searchPlaceholder: "Tìm chủ đề...",
    menu: "Mở menu",
    home: "Trang chủ",
  },
  avatar: {
    profile: "Hồ sơ",
    openProfile: "Mở cài đặt hồ sơ",
    myTopics: "Chủ đề của tôi",
    myVocabulary: "Từ vựng của tôi",
    takeTour: "Xem hướng dẫn",
    signOut: "Đăng xuất",
    signedOutTitle: "Đã đăng xuất",
    signedOutDescription: "Bạn đã đăng xuất thành công.",
    /** Nhãn nhóm ngôn ngữ + giao diện ở cuối menu hồ sơ. */
    device: "Thiết bị này",
    streak: {
      idle: "Bắt đầu chuỗi hôm nay",
      active: "Chuỗi {{count}} ngày",
      dayWord: "ngày",
      openActive: "Chuỗi {{count}} ngày — xem chi tiết chuỗi",
      openIdle: "Chưa có chuỗi nào — xem chi tiết chuỗi",
    },
    level: "Cấp {{level}}",
    levelProgress: "Tiến độ lên cấp tiếp theo",
    xp: "{{count}} XP",
    theme: {
      label: "Giao diện",
      light: "Sáng",
      dark: "Tối",
      system: "Hệ thống",
      lightAria: "Giao diện sáng",
      darkAria: "Giao diện tối",
      systemAria: "Giao diện hệ thống",
    },
  },
  mobile: {
    more: "Thêm",
    tabBar: "Điều hướng chính",
  },
  /** Landing-page header links (apps/www shell is separate). */
  landing: {
    about: "Giới thiệu",
    updates: "Cập nhật",
  },
  breadcrumbHome: "Trang chủ",
  };
